"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.types = exports.errors = exports.parseMediaSrc = exports.createMediaSrc = exports.isValidMediaSrc = void 0;
const mediaItemUtils = __importStar(require("./mediaItemUtils"));
const common_1 = require("./common");
Object.defineProperty(exports, "types", { enumerable: true, get: function () { return common_1.types; } });
Object.defineProperty(exports, "errors", { enumerable: true, get: function () { return common_1.errors; } });
const matchers = {
    externalUrl: /(^https?)|(^data)|(^blob)|(^\/\/)/,
    inlineSvg: /<svg[\s\S]*>[\s\S]*<\/svg>/im,
};
const extraMatchersByType = {
    [mediaItemUtils.types.VECTOR]: [matchers.externalUrl, matchers.inlineSvg],
    [mediaItemUtils.types.IMAGE]: [matchers.externalUrl],
    [mediaItemUtils.types.DOCUMENT]: [],
    [mediaItemUtils.types.VIDEO]: [],
    [mediaItemUtils.types.AUDIO]: [matchers.externalUrl],
};
/**
 * Create a MediaItem in the form of 'wix:<media_type>:<uri>/...' or extra supported source(e.g., external url) of one of the supported type
 */
function createMediaSrc({ mediaId, type, title, width, height, posterId, watermark, duration, }) {
    var _a;
    if (
    // @ts-ignore
    (_a = extraMatchersByType[type]) === null || _a === void 0 ? void 0 : _a.some(matcher => matcher.test(mediaId))) {
        return { item: mediaId };
    }
    return mediaItemUtils.createMediaItemUri({
        mediaId,
        type,
        title,
        width,
        height,
        posterId,
        watermark,
        duration,
    });
}
exports.createMediaSrc = createMediaSrc;
/**
 * Parse a media item url of one of the supported types, including extra source type(e.g. external url)
 */
function parseMediaSrc(mediaItemSrc, type) {
    if (!Object.values(common_1.types).includes(type)) {
        return { error: common_1.errors.unknown_media_type };
    }
    if (extraMatchersByType[type].some(matcher => matcher.test(mediaItemSrc))) {
        return { type, mediaId: mediaItemSrc };
    }
    const mediaItemUri = mediaItemUtils.parseMediaItemUri(mediaItemSrc);
    if (mediaItemUri.error === common_1.errors.non_string_media_id) {
        return mediaItemUri;
    }
    if (mediaItemUri.error === common_1.errors.unknown_media_type ||
        type !== mediaItemUri.type) {
        return { error: common_1.errors.bad_media_id };
    }
    return mediaItemUri;
}
exports.parseMediaSrc = parseMediaSrc;
/**
 * Checks if a given url is a valid media source url
 */
function isValidMediaSrc(mediaSrc, type) {
    const isValidMediaItemUri = mediaItemUtils.isValidMediaItemUri(mediaSrc, type);
    return (isValidMediaItemUri ||
        (extraMatchersByType[type] &&
            extraMatchersByType[type].some(matcher => matcher.test(mediaSrc))));
}
exports.isValidMediaSrc = isValidMediaSrc;
//# sourceMappingURL=mediaSrcHandler.js.map